export default __webpack_public_path__ + "static/media/plantsInPots.1f812db3.jpg";